module.exports = __webpack_public_path__ + "media/images/front/banner_minpre_240618-6cb14437c930840eae8940f8d213e636.jpg";